<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="congressEdition.name"
          :label="$t('form.communication.congress_edition')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" lg="5">
        <v-text-field
          v-model="communication.type"
          :label="$t('form.communication.type')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" lg="4">
        <v-text-field
          v-model="communication.date"
          :label="$t('form.communication.date')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" lg="3">
        <v-checkbox
          readonly
          v-model="communication.presented_on_main"
          :label="$t('form.communication.presented_on_main')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="communication.lecture_notes"
          :label="$t('form.communication.lecture_notes')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
                v-model="communication.prizes"
                :label="$t('form.communication.prizes')"
                required
                readonly
                filled
                outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>

    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DetailCommunication",
  props: {
    communication: Object
  },
  data: () => ({
    congressEdition: ""
  }),

  created() {
    this.getCongressEdition(this.communication.congress_edition);
  },
  methods: {
    getCongressEdition(id) {
      let path = this.$store.state.endpoint + "/congressEdition/" + id;
      axios
        .get(path)
        .then(response => {
          this.congressEdition = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
